import {
  BookedStatusEnum,
  EventAudienceEnum,
  EventStatusEnum,
} from '../../../../store/events/eventTypes';
import { Expose, Type } from 'class-transformer';
import { EventCategoryModel } from '../../../event/dto/models/event-category.model';
import { EventSubCategoryModel } from '../../../event/dto/models/event-sub-category.model';
import { EventParticipantWithUserImpl } from '../../../event/dto/implements/event-participant-with-user.impl';
import { EventResourceWithRelationsImpl } from '../../../event/dto/implements/event-resource-with-relations.impl';

export class GetGymEventResponseDto {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'name' })
  name: string;
  @Expose({ name: 'description' })
  description: string;
  @Expose({ name: 'audience' })
  audience: EventAudienceEnum;
  @Expose({ name: 'category' })
  @Type(() => EventCategoryModel)
  category: EventCategoryModel;
  @Expose({ name: 'category_id' })
  categoryId: number;
  @Expose({ name: 'sub_category' })
  @Type(() => EventSubCategoryModel)
  subCategory: EventSubCategoryModel;
  @Expose({ name: 'sub_category_id' })
  subCategoryId: number;
  @Expose({ name: 'free_site_name' })
  freeSiteName: string;
  @Expose({ name: 'resource_id' })
  resourceId: number;
  @Expose({ name: 'from_date' })
  fromDate: number;
  @Expose({ name: 'to_date' })
  toDate: number;
  @Expose({ name: 'capacity' })
  capacity: number;
  @Expose({ name: 'booked_status' })
  bookedStatus: BookedStatusEnum;
  @Expose({ name: 'status' })
  status: EventStatusEnum;
  @Expose({ name: 'credit_allowed' })
  creditAllowed: boolean;
  @Expose({ name: 'enable_credit_use' })
  enableCreditUse: boolean;
  @Expose({ name: 'image' })
  image: string;
  @Expose({ name: 'price' })
  price: number;
  @Expose({ name: 'policy_id' })
  policyId: number;
  @Expose({ name: 'resource' })
  @Type(() => EventResourceWithRelationsImpl)
  resource: EventResourceWithRelationsImpl;
  @Expose({ name: 'participants' })
  @Type(() => EventParticipantWithUserImpl)
  participants: EventParticipantWithUserImpl[];
  @Expose({ name: 'item' })
  item: any;
}
